export const useImageTransform = () => {
   const imageToImageEditing = async (prompt: {
      style: string;
      substyle: string;
      prompt: string;
      strength: number;
      url: string;
      num_images?: number;
      template_type?: string;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/transform-image`, {
            method: 'POST',
            body: JSON.stringify(prompt),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         // const res = await fetch(`${process.env.REACT_APP_API_URL}/api/replace-background`, {
         //    method: 'POST',
         //    body: JSON.stringify(prompt),
         //    headers: {
         //       'Content-Type': 'application/json',
         //    },
         // });
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const replaceBackground = async (prompt: {
      style: string;
      substyle: string;
      prompt: string;
      url: string;
      num_images?: number;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/replace-background`, {
            method: 'POST',
            body: JSON.stringify(prompt),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const removeBackground = async (url: string) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/remove-background`, {
            method: 'POST',
            body: JSON.stringify({ url }),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const generateImage = async (params: {
      prompt: string;
      style: string;
      substyle: string;
      num_images?: number;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/generate-image`, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const crispUpscale = async (url: string) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/crisp-image`, {
            method: 'POST',
            body: JSON.stringify({ url }),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   return {
      generateImage,
      imageToImageEditing,
      replaceBackground,
      removeBackground,
      crispUpscale,
   };
};

export default useImageTransform;
